/*global createCalendar */
void (function initOar() {
	'use strict';

	function createToken() {
		const radix = 36;
		const indexAfterDecimalPoint = 2;
		const maxIndex = 15;
		return (
			Math.random()
				.toString(radix)
				.substring(indexAfterDecimalPoint, maxIndex) +
			Math.random()
				.toString(radix)
				.substring(indexAfterDecimalPoint, maxIndex)
		);
	}

	function getURLParameters(url) {
		const result = {};
		const _url = url.replace('/', '').replace('?', '').replace('%20', ' ');
		_url.split('&').forEach((k) => {
			const item = k.split('=');
			if (item[0] !== '') {
				result[item[0]] = item[1];
			}
		});
		return result;
	}

	function formatPhone(obj) {
		const maxLength = 10;
		const numbers = obj.value.replace(/\D/g, '');
		const char = {
			0: '(',
			3: ') ',
			6: '-',
		};
		obj.value = '';
		for (
			let i = 0;
			i < (numbers.length < maxLength ? numbers.length : maxLength);
			i++
		) {
			obj.value += (char[i] || '') + numbers[i];
		}
	}

	function formCaptureFields(form) {
		if (!form) return undefined;
		const data = {};
		for (let i = 0, ii = form.length; i < ii; ++i) {
			const input = form[i];
			if (input.name) {
				if (input.type === 'checkbox' || input.type === 'radio') {
					if (input.checked) {
						if (data[input.name]) {
							if (typeof data[input.name] === 'string') {
								data[input.name] = [data[input.name]];
							}
							// data[input.name] += `, ${input.value}`;
							data[input.name].push(input.value);
						} else {
							data[input.name] = input.value;
						}
					}
				} else {
					if (input.value !== '') {
						data[input.name] = input.value;
					}
				}
			}
		}
		return data;
	}

	function processForm(settings) {
		if (!settings) {
			settings = {};
		}
		const form = document.getElementById(settings.formID);
		if (!form) return;
		form.onsubmit = function onSubmit(e) {
			e.preventDefault();
			form.classList.add('submitted');
			const data = formCaptureFields(form);
			const formStatus = document.createElement('div');
			formStatus.classList.add('form-status', 'alert');
			form.appendChild(formStatus);
			const xhr = new XMLHttpRequest();
			xhr.open(form.method, form.action, true);
			xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
			xhr.setRequestHeader(
				'Content-Type',
				'application/x-www-form-urlencoded; charset=UTF-8',
			);
			xhr.send(JSON.stringify(data));
			xhr.onloadend = function handleResponse(response) {
				const failedStatus = 0;
				const badRequestStatus = 400;
				const successStatus = 200;
				if (response.target.status === failedStatus) {
					formStatus.classList.add('error');
					formStatus.innerHTML = form.dataset.errorUnknown;
				} else if (response.target.status === badRequestStatus) {
					formStatus.classList.add('error');
					formStatus.innerHTML = form.dataset.errorUnknown;
				} else if (response.target.status === successStatus) {
					formStatus.classList.add('success');
					formStatus.innerHTML = form.dataset.success;
					if (settings.callback) {
						settings.callback(form, response.target.status);
					}
				}
			};
		};
	}

	function formCompleteOAR(form) {
		form.parentElement.parentElement
			.querySelector('.form-appointment')
			.classList.toggle('hide');
		form.parentElement.parentElement
			.querySelector('.form-thankyou')
			.classList.toggle('hide');
		document.getElementById('oar-survey').elements.FirstName.value =
			form.elements.FirstName.value;
		if (form.elements.IsNewPatient.value === 'false') {
			document.querySelector('#oar-survey .survey').remove();
			return;
		}
		processForm({ formID: 'oar-survey' });
	}

	function processOARForms() {
		const form = document.getElementById('oar-main');
		if (!form) return;
		const phones = form.querySelectorAll('input[type="tel"]');
		[].forEach.call(phones, (e) => {
			e.addEventListener('blur', () => {
				formatPhone(e);
			});
		});
		document.querySelectorAll('[data-enables]').forEach((item) => {
			const subgroup = document.getElementById(item.dataset.enables);

			if (item.checked) {
				subgroup.classList.add('show');
			}

			const group = document.querySelectorAll(
				`input[name="${item.name}"]`,
			);
			group.forEach((i) => {
				const monitorChange = function monitorChange() {
					if (item.checked) subgroup.classList.add('show');
					else subgroup.classList.remove('show');
				};
				i.addEventListener('input', monitorChange, false);
			});
		});
		const uid = createToken();
		form.elements.uid.value = uid;
		document.getElementById('oar-survey').elements.uid.value = uid;
		const urlArgs = getURLParameters(window.location.search);
		const src = urlArgs.src;
		form.elements.src.value = src;
		document.getElementById('oar-survey').elements.src.value = src;
		const passedServiceType = urlArgs.service;
		// virtual, cleaning, implants, cosmetic, consultation, emergency
		const radios = form.querySelectorAll('input[name=AppointmentReasons]');
		radios.forEach((option) => {
			if (option.value === passedServiceType) option.checked = true;
		});
		if (passedServiceType === 'virtual') {
			form.querySelector('section.intro-data').style.display = 'none';
			document.querySelector('.form-appointment h1').innerHTML =
				'Schedule Your Virtual Appointment';
		}
		processForm({
			formID: 'oar-main',
			callback: formCompleteOAR,
		});
	}

	function formatDay(date) {
		const WEEK_DAYS = [
			'Sunday',
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
		];
		const CALENDAR_MONTHS = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		const today = new Date();
		const curYear = today.getUTCFullYear();
		const dateObj = new Date(date);
		const weekDay = WEEK_DAYS[dateObj.getUTCDay()];
		const month = CALENDAR_MONTHS[dateObj.getUTCMonth()];
		const year = dateObj.getUTCFullYear();
		const numDate = dateObj.getUTCDate();
		return `${weekDay}, ${month} ${numDate}${
			year === curYear ? '' : `, ${year}`
		}`;
	}

	function formatTime(time) {
		const hourLength = 2;
		const pmBoundary = 12;
		let hour = parseInt(time.slice(0, hourLength), 10);
		let ap = '';
		if (hour >= pmBoundary) {
			ap = 'PM';
			if (hour !== pmBoundary) {
				hour = hour - pmBoundary;
			}
		} else {
			ap = 'AM';
			if (hour === 0) {
				hour = pmBoundary;
			}
		}

		const minuteLength = 2;
		const minuteStart = 3;
		const minute = time.slice(minuteStart, minuteStart + minuteLength);

		return `${hour}:${minute} ${ap}`;
	}

	function processOARConfirm() {
		const form = document.getElementById('oar-confirm');
		if (!form) return;
		const urlArgs = getURLParameters(window.location.search);
		let message = form.dataset.message;

		if (urlArgs.dt && urlArgs.uid) {
			// Expected Date Format: 2019-04-15T14:30
			const dt = new Date(urlArgs.dt);
			const dtString = urlArgs.dt.split('T');
			const date = formatDay(new Date(dtString[0]));
			const time = formatTime(dtString[1]);

			message = `<p>Thank you for confirming your appointment with us.</p>
        <span class="time">${time}</span> on <span class="date">${date}</span>
        <p>Should you need to change or cancel please call the office at ${form.dataset.phone}.</p>`;

			const expectedDateLength = 11;
			if (dtString[1].length === expectedDateLength) {
				const apptEvent = createCalendar({
					options: {
						class: 'calendars',
						id: 'calendars',
					},
					data: {
						title: 'Dentist Appointment',
						start: dt,
						duration: 60,
						description: 'Dentist Appointment',
					},
				});
				form.querySelector('.appt-details .calendar').appendChild(
					apptEvent,
				);
			}
		}

		form.querySelector('.appt-details .message').innerHTML = message;
		const uid = urlArgs.uid;
		form.elements.uid.value = uid;
		form.elements.FirstName.value = urlArgs.test ? 'TEST' : '';

		const xhr = new XMLHttpRequest();
		const data = formCaptureFields(form);
		xhr.open(form.method, form.action, true);
		xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
		xhr.setRequestHeader(
			'Content-Type',
			'application/x-www-form-urlencoded; charset=UTF-8',
		);
		xhr.send(JSON.stringify(data));
	}

	function processOARCancel() {
		const form = document.getElementById('oar-cancel');
		if (!form) return;
		const urlArgs = getURLParameters(window.location.search);
		const uid = urlArgs.uid;
		form.elements.uid.value = uid;
		form.elements.FirstName.value = urlArgs.test ? 'TEST' : '';
		processForm({ formID: 'oar-cancel' });
	}

	document.addEventListener('DOMContentLoaded', () => {
		processOARForms();
		processOARConfirm();
		processOARCancel();
	});
})();
